import React from 'react'
import { Link } from 'react-router-dom';
import './About.scss'
import { images } from '../../constants'

const About = ({DarkMode, setDarkmode}) => {
  return (
    <div className='about-page' id='about' 
      style={{backgroundColor: DarkMode?'var(--primary-color)':'var(--primary-color)',
              color: DarkMode?'var(--darkgray-color)':'var(--darkgray-color)'}}>
      <div className='about-page-upper' data-aos="fade-right">
        <h1>I am a passionate designer and artist.</h1>
      </div>
      <div className='about-page-lower'>
        <div className='about-page-left' data-aos="fade-right">
          <img className='propic' src={images.propic} alt="propic" />
          <img className='line' src={DarkMode?images.blackline:images.blackline} alt="line" />
        </div>
        <div className='about-page-right' data-aos="fade-up">
          <p>Hi! I am Henning. I have strong passion for design. I major in Electrical Engineering at NTU and I am also the minister of marketing department at NTUEE.</p>
        </div>
      </div>
      <div className='about-page-skills'>
        <div className='about-page-skill-title' data-aos="fade-right">
          <h1>My skills</h1>
        </div>
        <div className='about-page-skills-description'>
          <h3 data-aos="fade-up">Computer software is essential in my artwork creation process. It enables me to sketch,
             paint, and manipulate images digitally. With a variety
              of tools and features, I can experiment with different techniques, colors, and textures. 
              Digital editing software helps refine and enhance my artwork, while boosting efficiency and 
              offering endless artistic possibilities.</h3>
        </div>
        <div className='about-page-tools'>
          <div className='software-tool' data-aos="fade-up">
            <h2>Software / Tools</h2>
            {['Adobe Illustrator', 'Adobe Photoshop', 'Blender', 'AutoCAD', 'Fusion360', 'Figma', 'Procreate'].map((item) => (
              <p>{item}</p>
            ))}
          </div>
          <div className='web-programming' data-aos="fade-up">
            <h2>Web Development</h2>
            {['HTML5', 'CSS3', 'Javascript', 'ReactJS', 'MongoDB', 'Git'].map((item) => (
            <p>{item}</p>
          ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default About